import React, {useState, useEffect, useRef} from 'react';

import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { useLocation } from "react-router-dom";
// import { GridPDFExport } from "@progress/kendo-react-pdf";
// import { ExcelExport } from "@progress/kendo-react-excel-export";

import SvgIcon from '../../CustomeComponents/SvgIcon';
import Section from '../Section';
import VahadaDialog from './VahadaDialog';
import { getHahlatotContentData } from '../../server/ServerFunc';
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';

const VahadaInfo = ({ isSeparate }) => {
	const [hachlatotVahadaList, setHachlatotVahadaList] = useState([]);
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [dialogData, setDialogData] = useState({});
	const [isMobile, setIsMobile] = useState(false);
	const [systemCode, setSystemCode] = useState("");
	// const _exportRef = useRef(null);
	
	const search = useLocation().search;

	useEffect(() => {
		const tikNumURL = new URLSearchParams(search).get("TikNum");
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
		getHahlatotContent(systemCodeURL, tikNumURL);	
	}, []);

	// const exportPDF = () => {
	// 	if (dataExportPDF !== null) {
	// 		dataExportPDF.save();
	// 	}
	// };

	const getHahlatotContent = async (systemCode, tikNum) => { 
		const hachlatotVahadaData = await getHahlatotContentData(systemCode, tikNum);
		if(hachlatotVahadaData.length > 0) {
			setHachlatotVahadaList(hachlatotVahadaData);
		} else {
			setHachlatotVahadaList([]);
		}
		setIsMobile(window.innerWidth < 768);
		setSystemCode(systemCode);
	}

	const titles = {
		"descSugDiun": "סוג דיון",
		"vaadaDate": "מועד ביצוע",
		"vaadaContent": "החלטות הוועדה"
	}

	const handleToggleDialog = (data) => {
		setIsDialogOpen(!isDialogOpen);
		setDialogData(data);
	}
	
	const LabeledDataItem = (label, value) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			<div className="value">{value}</div>
		</div>
	}

	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field])}
		</td>
	}

	const SvgIconCell = (props) => {
    const data = props.dataItem;
		return <td {...props.tdProps} className="icon-cell">
			{LabeledDataItem('קישור', <SvgIcon icon={"eye"} style={{ cursor: 'pointer' }} onClick={() => handleToggleDialog(data)} />)}
		</td>
	}

	// const exportToExcel = () => {
	// 	if (_exportRef.current !== null) {
	// 		// console.log('_exportRef.current: ', _exportRef.current)
	// 		const tableData = _exportRef.current.props.data;
	// 		// console.log('tableData: ', tableData);
	// 		const options = _exportRef.current.workbookOptions();
	// 		// console.log('options: ', options);
	// 		const rows = options.sheets[0].rows;
	// 		// console.log('rows: ', rows);
	// 		rows.forEach((row, i) => {
	// 			// console.log('i', i);
	// 			if (row.type === "data") {
	// 			  console.log('row: ', row) 
	// 				if (tableData[i - 1].descSugDiun === row.cells[0].value && tableData[i - 1].vaadaDate === row.cells[1].value) {
	// 					//1.
	// 					//dangerouslySetInnerHTML={{ __html: vahadaDialogData.hamhahTochen }}
	// 					//row.cells[2].value = dangerouslySetInnerHTML

	// 					//2. 
	// 					row.cells[2].value = tableData[i - 1].hamhahTochen;

	// 					// const parser = new DOMParser();
	// 					// const stringHtml = parser.parseFromString(tableData[i - 1].hamhahTochen, 'text/html');
	// 					// console.log('stringHtml', stringHtml);
	// 					// const blob = new Blob([stringHtml], { type: 'text/html' });
	// 					// console.log('blob', blob);
	// 					// // row.cells[2].value = `${html}`;
	// 					// const link = document.createElement('a');
	// 					// link.href = URL.createObjectURL(blob);

	// 					// row.cells[2].value = link.href;
	// 					// URL.revokeObjectURL(link.href);
	// 				}
	// 			}
	// 		  });

	// 		_exportRef.current.save(options);
	// 		//_exportRef.current.save();
	// 	}
	// };

	const TableVahadaList = () => {
		return (
			// <ExcelExport data={hachlatotVahadaList} fileName="החלטות הועדה.xlsx"  ref={_exportRef}>
				<Grid data={hachlatotVahadaList} >
					{/* <GridToolbar>
						<SvgIcon icon={"file-exe"} title="ייצא לאקסל" onClick={exportToExcel} style={{ cursor: "pointer", marginRight: "1000px" }}/>
					</GridToolbar> */}
					
					<GridColumn field="descSugDiun" title={titles.descSugDiun} cell={LabeledCell} />
					<GridColumn field="vaadaDate" title={titles.vaadaDate} cell={LabeledCell} />
					<GridColumn field="vaadaContent" title={titles.vaadaContent} cell={SvgIconCell} headerClassName={'icon-header-cell'} />
				</Grid>
			// </ExcelExport>
		)
	}

	return (
		<>
			{isSeparate && <AppHeaderGlobal />}
			{
				systemCode === "26400046" ?
					<>
						<div style={{ margin: `${isMobile ? "-135px 0px 0px 0px" : (!isSeparate ? "-115px 0px 0px 0px" : "")}`, backgroundColor: "white" }} >
						<div className="container my-3 my-lg-5" >
							{/* <div className={"exportPDF"}>
								<a onClick={() => exportPDF()}> <SvgIcon icon={"file-exe"} /> </a>
							</div> */}
							<Section icon={'hammer'} title={'החלטות הועדה'} className="mt-3">
								{
									hachlatotVahadaList.length > 0 ?
										// <GridPDFExport ref={(pdfExport) => (dataExportPDF = pdfExport)}>
										<TableVahadaList />
										// </GridPDFExport>
										:
										<div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
								}
							</Section>
						</div>
					</div>
					{isDialogOpen && <VahadaDialog closeDialog={handleToggleDialog} vahadaDialogData={dialogData} />}
					</>
					:
					<>
						<div className="container my-3 my-lg-5" >
							{/* <div className={"exportPDF"}>
								<a onClick={() => exportPDF()}> <SvgIcon icon={"file-exe"} /> </a>
							</div> */}
							<Section icon={'hammer'} title={'החלטות הועדה'} className="mt-3">
								{
									hachlatotVahadaList.length > 0 ?
										// <GridPDFExport ref={(pdfExport) => (dataExportPDF = pdfExport)}>
										<TableVahadaList />
										// </GridPDFExport>
										:
										<div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
								}
							</Section>
						</div>
						{isDialogOpen && <VahadaDialog closeDialog={handleToggleDialog} vahadaDialogData={dialogData} />}
					</>
					
			}
			{isSeparate && <AppFooter />}
		</>
	)
}

export default VahadaInfo